/**
 * Rewrites BeyondCart discount labels in third-party UI we cannot edit
 * (e.g. Sendica pickup-points dialog #spp-dialog).
 *
 * "beyondcart_apptc_BASE20" → "APPTC_BASE20"
 * Leaves the real discount codes untouched in Shopify/cart Liquid.
 */
(function () {
  const DIALOG_SELECTOR = '#spp-dialog';

  function formatLabel(text) {
    if (!text || !/beyondcart_/i.test(text)) return text;
    return text.replace(/\bbeyondcart_([A-Za-z0-9_]+)/gi, function (_match, rest) {
      return String(rest).toUpperCase();
    });
  }

  function shouldSkipElement(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return true;
    const tag = el.tagName;
    return (
      tag === 'SCRIPT' ||
      tag === 'STYLE' ||
      tag === 'NOSCRIPT' ||
      tag === 'TEXTAREA' ||
      tag === 'INPUT' ||
      tag === 'SELECT' ||
      tag === 'OPTION'
    );
  }

  function rewriteTextNodes(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      const next = formatLabel(root.nodeValue);
      if (next !== root.nodeValue) root.nodeValue = next;
      return;
    }

    if (shouldSkipElement(root)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || shouldSkipElement(parent)) return NodeFilter.FILTER_REJECT;
        if (!node.nodeValue || !/beyondcart_/i.test(node.nodeValue)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    let current = walker.nextNode();
    while (current) {
      nodes.push(current);
      current = walker.nextNode();
    }

    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const next = formatLabel(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function processDialog(dialog) {
    if (!dialog) return;
    rewriteTextNodes(dialog);
  }

  function findDialog(fromNode) {
    if (!fromNode) return document.querySelector(DIALOG_SELECTOR);
    if (fromNode.nodeType === Node.ELEMENT_NODE) {
      if (fromNode.matches?.(DIALOG_SELECTOR)) return fromNode;
      if (fromNode.querySelector) {
        const nested = fromNode.querySelector(DIALOG_SELECTOR);
        if (nested) return nested;
      }
      return fromNode.closest?.(DIALOG_SELECTOR) || null;
    }
    return fromNode.parentElement?.closest?.(DIALOG_SELECTOR) || null;
  }

  let scheduled = false;
  function scheduleScan(target) {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      const dialog = findDialog(target) || document.querySelector(DIALOG_SELECTOR);
      if (dialog) processDialog(dialog);
    });
  }

  function start() {
    const existing = document.querySelector(DIALOG_SELECTOR);
    if (existing) processDialog(existing);

    const observer = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        if (mutation.type === 'characterData') {
          const dialog = findDialog(mutation.target);
          if (dialog) scheduleScan(dialog);
          continue;
        }

        if (mutation.type !== 'childList') continue;

        for (let j = 0; j < mutation.addedNodes.length; j++) {
          const node = mutation.addedNodes[j];
          const dialog = findDialog(node);
          if (dialog) {
            scheduleScan(dialog);
            break;
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
